import { useEffect, useRef, type ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSiteInteractions } from '../../hooks/useSiteInteractions';
import { useSmoothScroll } from '../../hooks/useSmoothScroll';
import { scrollToTop } from '../../lib/smoothScroll';
import { SiteFooter } from './SiteFooter';
import { SiteNavBar } from './SiteNavBar';
import '../../styles/site-motion.css';
import '../../styles/site-overrides.css';
import '../../styles/site-pages.css';
import '../../styles/site-footer.css';

interface SiteShellProps {
  children: ReactNode;
}

/** Shared chrome for every page - nav, footer, site interactions, 80vw layout. */
export function SiteShell({ children }: SiteShellProps) {
  const rootRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useSmoothScroll();
  useSiteInteractions(rootRef, navigate, pathname);

  useEffect(() => {
    document.body.className = 'site-page';
    scrollToTop({ immediate: true });
  }, [pathname]);

  return (
    <div ref={rootRef} className="site-root">
      <SiteNavBar />
      <div className="page-wrapper">
        <main className="site-main">{children}</main>
        <SiteFooter />
      </div>
    </div>
  );
}
